export const VARIANT_ON = 'on';
export const VARIANT_OFF = 'off';
export const VARIANT_A = 'a';
export const VARIANT_B = 'b';
export const VARIANT_MYACCOUNT = 'MyAccount';
export const VARIANT_LOGINSIGNUP = 'LoginSignup';
export const VARIANT_HIDE_TOGGLE = 'hideNewExistingToggle';
export const VARIANT_SHOW_TOGGLE = 'showNewExistingToggle';

/* Optimizely experiments */

// This experiment is used exclusively by nginx to determine whether to send the client to monolith or 1Z.
// We use it as a feature flag here in PWA to log to datadog when the client received the monolith variant but somehow
// ended up here in PWA.
export const ONE_Z_SEARCH = {
    experimentId: '1ZSearchRouter',
    defaultAssignment: 'default',
    isFeatureFlag: false,
};

// This experiment is used exclusively by PWA to record profile conversion.
// Nginx and monolith shouldn't touch this experiment at all.
export const ONE_Z_SEARCH_PWA = {
    experimentId: '1ZSearchTest-PWA',
    defaultAssignment: VARIANT_ON,
    isFeatureFlag: false,
};

export const HOMEPAGE_HEADER_V2 = {
    experimentId: 'HomepageHeaderV2',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const UNIVERSAL_SEARCH_HEADER_PREVIEW = {
    experimentId: 'UniversalSearchHeaderPreview',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
};

export const SHOW_FACETED_SEARCHBAR = {
    experimentId: 'FacetedSearchBar',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const SHOW_REVIEW_COUNT = {
    experimentId: 'FlapjackReviewCount',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const NEW_EXISTING_PROFILE_TOGGLE = {
    experimentId: 'NewExistingProfilePage',
    defaultAssignment: VARIANT_HIDE_TOGGLE,
    isFeatureFlag: false,
    recordManually: true,
};

export const SALP_PAGE_SEO = {
    experimentId: 'SalpPageSeoTest',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const SALP_PAGE_FOOTER = {
    experimentId: 'SalpPageFooterTest',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const WELL_GUIDE_HEADER_NAVIGATION = {
    experimentId: 'Pina_WellGuide_HeaderNavigation',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
};

export const PINA_INSURANCE_PICKER_USE_DROPDOWN_CHEVRON = {
    experimentId: 'Pina_InsurancePicker_UseDropdownHeaderChevron',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
    recordManually: true,
};

export const EVENT_LOOP_TEST = {
    experimentId: 'EventLoopTest',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const TELEHEALTH_LINK_TO_PROFILE = {
    experimentId: 'TelPWA_LinkToProfile',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: false,
};

export const FULL_STORY = {
    experimentId: 'FullStory',
    defaultAssignment: VARIANT_OFF,
    isFeatureFlag: true,
};
